import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AuthService } from './core/auth/auth.service';
import { ConfigService } from './core/config.service';
import { DomainTerminologyTranslationService } from './core/domain-terminology/domain-terminology-translation.service';
import { LicensingService } from './core/licensing/licensing.service';
import { SystemSettings } from './core/system-configuration/system-settings';
import { NotificationService } from './notifications/notification.service';

@Component({
  selector: 'hb-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnDestroy,OnInit {
  private unsubscribe: Subject<boolean> = new Subject();
  private _route: Router;
  public UserAuthenticated: boolean;
  public loggedInUser: string;

  public readonly zIndexPopover: number = 1060;

  private isError: boolean = false;

  constructor(
    router: Router,
    private authService: AuthService,
    private licenceService: LicensingService,
    private messageService: MessageService,
    private notificationService: NotificationService,
    private systemSettings: SystemSettings,
    private domainTerminologyTranslation: DomainTerminologyTranslationService,
    private configService: ConfigService,
    public bsModalRef: BsModalRef,
  ) {
    this._route = router;
    moment.tz.setDefault('Etc/UTC'); // set date for whole app to UTC

    if (!this.configService.AnyError) {
      this.authService.loggedIn.pipe(takeUntil(this.unsubscribe)).subscribe(data => {
        this.UserAuthenticated = data;

        if (this.UserAuthenticated) {
          document.querySelector('body').classList.remove('sidebar-hidden');
          document.querySelector('body').classList.remove('homepage-background');
          this.licenceService.getCurrentLicenceObservable().pipe(take(1)).subscribe();
          this.systemSettings.initialiseSettings();
          this.domainTerminologyTranslation.init();
        } else {
          document.querySelector('body').classList.add('sidebar-hidden');
          document.querySelector('body').classList.add('homepage-background');
          this.licenceService.unloadCurrentLicence();
        }
      });

      this.authService.loggedInUser.pipe(takeUntil(this.unsubscribe)).subscribe(data => {
        this.loggedInUser = data;
      });

      this.notificationService.notificationAdded.pipe(takeUntil(this.unsubscribe)).subscribe(n => this.messageService.add(n));

    }

    this.configService.IsError.pipe(takeUntil(this.unsubscribe)).subscribe(n => this.isError = n);
  }

  public logout() {
    this.authService.logout();
  }

  public ngOnInit(): void {
    window.addEventListener('popstate', () => {
      window.location.reload();
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
}
